import api from './api';

const service = {
  async search(params) {
    return await api.get(`/aggregators/${params.aggregator_id}/resource-status/areas`, { params });
  },
}

export default service;
